import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#ad103d',
        // secondary: '#757575',
        secondary: '#b8b8b8',
        accent: '#e44e67',
      },
    },
  },
});
